<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">{{ cardTitle }}</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />

    <form @submit.prevent="subimtData()">
      <!--begin::Body-->
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">العنصر:</label>
            <select v-model="key" class="form-control">
              <option v-for="(val, key) in settingsKeys" :value="key" :key="key">{{ val }}</option>
            </select>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">نوع القيمة:</label>
            <select v-model="valType" class="form-control">
              <option v-for="(val, key) in typeChioces" :value="key" :key="key">{{ val }}</option>
            </select>
          </div>
        </div>

        <div class="row">
          <div class="col-12 mb-3">
            <label for="" class="form-label">القيمة:</label>
            <textarea v-model="val" class="form-control" rows="5" style="direction: ltr;"></textarea>
          </div>
        </div>
      </div>
      <!--end::Body-->
      <!--begin::Footer-->
      <div class="card-footer">
        <div class="row">
          <div class="col text-end">
            <button v-if="!formLoader" type="submit" class="btn btn-success">ارسل</button>
            <loader v-if="formLoader" />
          </div>
        </div>
      </div>
      <!--end::Footer-->
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import { toast } from '@/helpers/tools';

export default {
  name: 'SettingsForm',
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
    typeChioces: {
      type: Object,
      default: null,
    },
    settingsKeys: {
      type: Object,
      default: null,
    },
  },
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      key: null,
      valType: null,
      val: null,
    }
  },
  methods: {
    subimtData(){
      this.formLoader = true;
      this.hasError = false;
      this.hasSucess = false;
      
      if(!this.key || this.key.trim() == '' || !this.valType || this.valType.trim() == '' || !this.val || this.val.trim() == ''){
        this.message = 'كل الحقول مطلوبة';
        this.errorNumber = 0;
        this.hasError = true;
        return false;
      }
      let payload = {
        key: this.key,
        valType: this.valType,
        val: this.val,
      }
      let api = null;
      if(this.dataRow)
        api = this.$http.put(`/api/admin/settings/update/${this.dataRow.id}`, payload);
      else
        api = this.$http.post('/api/admin/settings/create', payload);
      api.then(({data}) => {
        if(!this.dataRow){
          toast('تم إضافة الإعداد بنجاح', 'success');
          this.$router.replace('/settings').catch(() => {});
        }else{
          this.message = 'تم التعديل بنجاح';
          this.hasSucess = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        this.formLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
      });
    },
  },
  created(){
    if(this.dataRow){
      this.key = this.dataRow.key;
      this.valType = this.dataRow.valType;
      this.val = this.dataRow.val;
    }
  }
}
</script>
